<template>
  <div class="margin-top-130 col-md-7 padding-left-130">
    <div class="col-md-8">
      <Form @submit="handleLogin" :validation-schema="schema">
        <div class="row mb-4">
          <label class="input_label_text mb-2">Email</label>
          <Field
            type="email"
            class="form-control input_field px-3"
            name="username"
            id="username"
            v-model="username"
          />
        </div>
        <div class="row mb-5">
          <div class="d-flex justify-content-between">
            <label class="form-label input_label_text">Password</label>
            <label class="form-label">
              <router-link
                style="color: #717171 !important"
                :to="{ name: 'forgotPassword' }"
                >Forgot Password</router-link
              ></label
            >
          </div>
          <div class="password-input-container">
            <Field
              :type="showPassword == true ? 'text' : 'password'"
              class="form-control input_field password-input"
              name="password"
              id="password"
              v-model="password"
            />
            <font-awesome-icon
              @click="showPassword = !showPassword"
              style="cursor: pointer"
              class="field-icon"
              :icon="showPassword == true ? 'eye' : 'eye-slash'"
            />
          </div>
        </div>
        <div class="row mb-4 d-flex align-items-baseline">
          <div class="col-md-7 col-lg-5 col-xl-4">
            <button :disabled="loading" type="submit" class="signinbtn mb-3">
              <span class="signintext">
                {{ loading ? "Please wait..." : "Login" }}
              </span>
            </button>
          </div>
          <div class="col-md-12 col-lg-12 col-xl-8 text-xl-end text-lg-start">
            <span class="account_text col-md-6">
              Don’t have an account?
              <u>
                <router-link class="theme-color" :to="{ name: 'signup' }"
                  >Sign Up</router-link
                >
              </u>
            </span>
          </div>
        </div>
      </Form>
      <NotifierComponent
        class="mt-5"
        :message="message"
        :errors="errors"
        :notify="notify"
      />
    </div>
  </div>
</template>

<script>
import { Form, Field } from "vee-validate";
import NotifierComponent from "@/components/Notifier";
export default {
  name: "SignInView",

  data() {
    return {
      keep_sign_in: true,
      showPassword: false,
      loading: false,
      message: "",
      notify: false,
      errors: "",
    };
  },
  components: {
    Form,
    Field,
    NotifierComponent,
  },
  mounted() {},
  methods: {
    handleLogin(user) {
      this.loading = true;
      this.$store.dispatch("auth/login", user).then(
        (response) => {
          if (
            response.status_code == 200 &&
            response.data.user.user_type == 2
          ) {
            this.message = response.message;
            this.notify = true;
            this.loading = false;
            this.mixin_setLoginData(true, response);
            setTimeout(() => this.$router.push({ path: "/home" }), 1000);
          } else {
            this.message = "Sorry Unauthorized User !";
            this.notify = true;
            this.loading = false;
          }
        },
        (error) => {
          this.message = Object.values(error.response.data).flat();
          this.notify = true;
          this.loading = false;
        }
      );
    },
  },
};
</script>

<style scoped>
.field-icon {
  float: right;
  margin-right: 10px;
  margin-top: -26px;
  position: relative;
  z-index: 2;
  font-weight: 100;
  font-size: 13px;
  color: #ababab;
}
</style>
